(function (window) {
  'use strict';

  function bindSwipe(el, onPrev, onNext, options) {
    if (!el || typeof onPrev !== 'function' || typeof onNext !== 'function') return;

    options = options || {};
    var threshold = options.threshold || 35;
    var restraint = options.restraint || 80;
    var allowedTime = options.allowedTime || 600;
    var mobileMq = options.mobileMq || '(max-width: 749px)';

    var startX = 0;
    var startY = 0;
    var startTime = 0;

    function isMobile() {
      return window.matchMedia(mobileMq).matches;
    }

    el.addEventListener('touchstart', function (e) {
      if (!isMobile()) return;
      var touch = e.changedTouches[0];
      startX = touch.pageX;
      startY = touch.pageY;
      startTime = Date.now();
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (!isMobile()) return;
      var touch = e.changedTouches[0];
      var distX = touch.pageX - startX;
      var distY = touch.pageY - startY;
      var elapsed = Date.now() - startTime;

      if (elapsed > allowedTime) return;
      if (Math.abs(distX) < threshold) return;
      if (Math.abs(distY) > restraint && Math.abs(distY) > Math.abs(distX)) return;

      if (distX < 0) onNext();
      else onPrev();
    }, { passive: true });
  }

  window.TgTouchSlider = { bind: bindSwipe };
})(window);
